import { SVGProps } from 'react';

export default function Location10(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3392)">
        <path
          d="M18.1642 4.64915L12.3308 0.712478C11.6432 0.245664 10.8312 -0.00390625 10 -0.00390625C9.16885 -0.00390625 8.35685 0.245664 7.66917 0.712478L1.83667 4.64915C1.27066 5.03005 0.807068 5.54437 0.486767 6.14675C0.166466 6.74913 -0.000702546 7.42107 2.2192e-06 8.10331V15.8333C2.2192e-06 18.1308 1.86917 20 4.16667 20H15.8333C18.1308 20 20 18.1308 20 15.8333V8.10331C20.0006 7.42119 19.8334 6.74938 19.5133 6.14704C19.1932 5.5447 18.7299 5.03031 18.1642 4.64915ZM13.3333 13.3333C13.3333 14.2525 12.5858 15 11.6667 15H8.33334C7.41417 15 6.66667 14.2525 6.66667 13.3333V9.99998C6.66667 9.08081 7.41417 8.33331 8.33334 8.33331H11.6667C12.5858 8.33331 13.3333 9.08081 13.3333 9.99998V13.3333ZM11.6667 9.99998L11.6683 13.3333H8.33334V9.99998H11.6667Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3392">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
